import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { useCityFilter } from 'hooks/form/search';
import { QaIdentifier, useQa } from 'hooks/useQa';

import { useLocationFilter } from '../__hooks/useLocationFilter';
import styles from '../Location.module.scss';
import {
    CityList as CityListType,
    LocationFilterType,
    RegionList,
} from '../types';

import CityList from './CityList';
import GroupedCityList from './GroupedCityList';
import Input from './Input';
import Overlay from './Overlay';

interface CityFilterProps {
    cityList: CityListType;
    regionList?: RegionList;
}

const CityFilter = ({ cityList, regionList }: CityFilterProps) => {
    const { t } = useTranslation();
    const [cityIdList, setCityIdList] = useCityFilter();
    const {
        isOpen,
        inputValue,
        currentSelection,
        isSelectionEmpty,
        overlayRef,
        setInputValue,
        onSelection,
        clearSelection,
        onSubmit,
        openOverlay,
    } = useLocationFilter(cityList, cityIdList, setCityIdList);
    const qaAttr = useQa(QaIdentifier.Search_Filter_Location_City);

    return (
        <div
            className={classNames(styles.Location, { [styles.Open]: isOpen })}
            ref={overlayRef}
            {...qaAttr}
        >
            <div>
                <Input
                    type={LocationFilterType.City}
                    placeholder={t('TRANS-all-locations')}
                    onOpen={openOverlay}
                    value={inputValue}
                    onValueChange={setInputValue}
                />
                {isOpen && (
                    <Overlay
                        type={LocationFilterType.City}
                        isSelectionEmpty={isSelectionEmpty}
                        onClearSelection={clearSelection}
                        onSubmit={onSubmit}
                    >
                        {regionList ? (
                            <GroupedCityList
                                list={regionList}
                                filter={inputValue}
                                onSelection={onSelection}
                                currentSelection={currentSelection}
                            />
                        ) : (
                            <CityList
                                filter={inputValue}
                                onSelection={onSelection}
                                currentSelection={currentSelection}
                                list={cityList}
                            />
                        )}
                    </Overlay>
                )}
            </div>
        </div>
    );
};

export default CityFilter;
